import { render, staticRenderFns } from "./customManage.vue?vue&type=template&id=77314142&scoped=true"
import script from "./customManage.vue?vue&type=script&lang=js"
export * from "./customManage.vue?vue&type=script&lang=js"
import style0 from "./customManage.vue?vue&type=style&index=0&id=77314142&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77314142",
  null
  
)

export default component.exports